import React, { useEffect, useMemo, useState } from "react";
import "./animatedNumber.css";

export default function AnimatedNumber({
  value,
  decimals = 2,
  className = "",
}) {
  const [displayValue, setDisplayValue] = useState(Number(value));
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) return;

    if (displayValue !== numericValue) {
      setIsAnimating(true);
      const timer = setTimeout(() => {
        setDisplayValue(numericValue);
        setIsAnimating(false);
      }, 650);

      return () => clearTimeout(timer);
    }
  }, [value, displayValue]);

  const fmt = useMemo(() => {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  }, [decimals]);

  if (!Number.isFinite(displayValue)) return <span className={className}>—</span>;

  return (
    <span className={`animated-number ${isAnimating ? "spin" : ""} ${className}`}>
      {fmt.format(displayValue)}
    </span>
  );
}
